function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 42 32",
    style: {
      enableBackground: "new 0 0 42 32",
      width: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M38,2.8L35.8,1c-0.3-0.2-0.7-0.3-1-0.2c-0.4,0-0.7,0.2-0.8,0.6l-1.7,4.5H2c-0.4,0-0.7,0.2-0.9,0.5 C0.9,6.6,0.8,7,0.9,7.4l4.4,14.9c0.2,0.5,0.6,0.8,1.1,0.8h20.8c0.5,0,0.9-0.3,1.1-0.7L30,18l2.5-6.2l0,0l1.7-4.3l0,0l0,0l1.4-3.7 l1,0.8c0.5,0.4,1.2,0.3,1.6-0.2C38.5,3.9,38.5,3.2,38,2.8z M31.4,8.2l-1.1,3H4.5l-0.9-3H31.4z M28.1,16.5H6l-0.8-3h24.2L28.1,16.5z  M26.4,20.8H7.3l-0.6-2h20.5L26.4,20.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 10.2,
    cy: 27,
    rx: 3.4,
    ry: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 24.4,
    cy: 27,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E51673"
    },
    cx: 32.2,
    cy: 22.4,
    r: 9
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.89cf15c2.svg";
export { ForwardRef as ReactComponent };